import { safetyTips } from '@/mocks/categories';

export default function Safety() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Stay Safe
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Vigorbuy Spreadsheet Safety Guide
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Learn how to shop safely and protect yourself with these essential tips for using product research resources.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-50 group-hover:bg-primary-100 transition-colors mb-4">
                <i className={`${tip.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2">
                {tip.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {tip.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}